export default __webpack_public_path__ + "static/media/wcard.79d843cb.png";